export default {"src":"/_next/static/media/fietsport.dc541977.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};